import React from "react";

import { useTranslation } from "react-i18next";

import { useLocation } from "react-router-dom";

import { LinkContext } from "../LinkProvider";
import { useContext } from "react";

function Button ( { className } ) {

    const { t } = useTranslation();

    const { link } = useContext(LinkContext);

    const location = useLocation();

    return(
        <div className={className}>
            <a href={link}>
                <div className={`px-[32px] py-[16px] flex items-center justify-center ${location.pathname === '/about' ? 'bg-[#1E1C21]' : 'bg-[#FE7320]'} rounded-[60px] hover:scale-[0.95] transition-all`}>
                    <p className={`uppercase ibm-plex ${location.pathname === '/about' ? 'text-[#FFFFFF]' : 'text-[#1E1C21]'} text-[14px] xl:text-[16px]`}>{t('main.4')}</p>
                </div>
            </a>
        </div>
    );
}

export default Button;